// extracted by mini-css-extract-plugin
module.exports = {"locations__list":"DiningList_locations__list__3zYAK"};